import { listenDialogsControls } from '@frontend/shared/src/utils/dialog';
import { PersistentHistory } from '@frontend/auction/src/helpers/PersistentHistory';
import { SPAList } from '@frontend/auction/src/components/spa-list';
import { SPAListPreview } from '@frontend/auction/src/components/spa-list-preview';

export class SPADialogHistory extends HTMLDialogElement {
  container: HTMLDivElement;

  constructor() {
    super();

    this.container = this.querySelector<HTMLDivElement>('.container')!;

    this.prepend(this.container);
  }

  connectedCallback() {
    listenDialogsControls('history', this.beforeOpen, this.afterClose);
  }

  beforeOpen = () => {
    const history = PersistentHistory.load();

    const items = history.map(list => {
      const listPreview = new SPAListPreview().init(list);

      listPreview.onlistremove = () => {
        listPreview.remove();

        PersistentHistory.delete(list.id);
      };

      listPreview.onlistload = () => {
        SPAList.singleton.load(list.items);
      };

      return listPreview;
    });

    this.container.append(...items);
  };

  afterClose = () => {
    this.container.innerHTML = '';
  };
}

customElements.define('spa-dialog-history', SPADialogHistory, { extends: 'dialog' });
